interface LogoutIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const LogoutIcon: React.FC<LogoutIconProps> = ({
  width = 20,
  height = 20,
  fill = "white"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.026 5.23202C11.1269 5.14786 11.2434 5.08441 11.3688 5.04529C11.4943 5.00617 11.6262 4.99215 11.757 5.00404C11.8879 5.01593 12.0151 5.05348 12.1315 5.11457C12.2478 5.17565 12.3509 5.25906 12.435 5.36003L15.768 9.36002C15.8558 9.46038 15.9227 9.57729 15.9646 9.70386C16.0066 9.83043 16.0228 9.96411 16.0123 10.097C16.0018 10.23 15.9649 10.3595 15.9036 10.4779C15.8423 10.5963 15.758 10.7013 15.6556 10.7867C15.5531 10.872 15.4347 10.9361 15.3071 10.975C15.1796 11.0139 15.0455 11.0269 14.9129 11.0132C14.7803 10.9995 14.6517 10.9595 14.5348 10.8954C14.4178 10.8313 14.3149 10.7445 14.232 10.64L10.898 6.64002C10.7284 6.43631 10.6465 6.17355 10.6705 5.90953C10.6945 5.6455 10.8224 5.40181 11.026 5.23202Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.026 14.768C10.8224 14.5982 10.6945 14.3545 10.6705 14.0905C10.6465 13.8265 10.7284 13.5637 10.898 13.36L14.232 9.36C14.3149 9.25555 14.4178 9.16872 14.5348 9.10464C14.6517 9.04055 14.7803 9.0005 14.9129 8.98683C15.0455 8.97317 15.1796 8.98617 15.3071 9.02507C15.4347 9.06397 15.5531 9.12798 15.6556 9.21335C15.758 9.29871 15.8423 9.4037 15.9036 9.52213C15.9649 9.64057 16.0018 9.77006 16.0123 9.90299C16.0228 10.0359 16.0066 10.1696 15.9646 10.2962C15.9227 10.4227 15.8558 10.5396 15.768 10.64L12.435 14.64C12.3509 14.741 12.2478 14.8244 12.1315 14.8855C12.0151 14.9465 11.8879 14.9841 11.757 14.996C11.6262 15.0079 11.4943 14.9939 11.3688 14.9547C11.2434 14.9156 11.1269 14.8522 11.026 14.768Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 10C14 10.2652 13.8946 10.5196 13.7071 10.7071C13.5196 10.8946 13.2652 11 13 11L5 11C4.73478 11 4.48043 10.8946 4.29289 10.7071C4.10536 10.5196 4 10.2652 4 10C4 9.73478 4.10536 9.48043 4.29289 9.29289C4.48043 9.10536 4.73478 9 5 9L13 9C13.2652 9 13.5196 9.10536 13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10Z"
        fill={fill}
      />
    </svg>
  );
};

export default LogoutIcon;
